import ContainerWrapper from './ContainerWrapper';

export default ContainerWrapper;
